import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'AI-assisted Code Generation',
                topics: [
                    'Using AI to generate boilerplate code for common tasks',
                    'AI-powered code generation for rapid prototyping',
                    'AI-assisted code generation for generating complex data models',
                    'AI-based code generation for creating RESTful APIs',
                ],
            },
            {
                title: 'AI-assisted code review',
                topics: [
                    'Identifying potential code smells and anti-patterns with AI-powered code review',
                    'Automatically detecting security vulnerabilities in code using AI',
                    'Using AI to detect and report on code duplication and redundancy',
                    'AI-based code review tools for identifying and resolving performance issues',
                ],
            },
            {
                title: 'AI-Based Bug Detection and Fixing',
                topics: [
                    'Automatically detecting and fixing common syntax errors with AI',
                    'Using AI to identify and resolve resource leaks in code',
                    'AI-powered bug detection for identifying and resolving concurrency issues',
                    'Using AI to automatically detect and resolve memory leaks in code',
                    'AI-assisted bug detection for identifying and resolving race conditions',
                ],
            },
            {
                title: 'AI-driven performance optimization and load testing',
                topics: [
                    'AI-powered load testing tools for identifying and resolving bottlenecks',
                    'Using AI to optimize database queries and improve query performance',
                    'Automatically detecting and resolving deadlocks with AI',
                    'AI-based load testing tools for identifying and resolving network latency issues',
                ],
            },
            {
                title: 'AI-driven Refactoring',
                topics: [
                    'AI-powered refactoring tools for improving code maintainability',
                    'Using AI to automatically refactor code for improved performance',
                    'Automatically refactoring code to improve code organization and structure',
                    'AI-based refactoring for improving code testability',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;